import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { LinearAlertModel } from '@/libs/Api';
import { LinearAlertsDataService } from '@/libs/alerts/linear-alerts-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const linearAlertsStore = registerCrudStore<LinearAlertModel, LinearAlertModel>(
    BusinessModule.LinearAlert,
    new LinearAlertsDataService()
);
